import { render, staticRenderFns } from "./OptionsPopover.vue?vue&type=template&id=149a8264&scoped=true&"
import script from "./OptionsPopover.vue?vue&type=script&lang=ts&"
export * from "./OptionsPopover.vue?vue&type=script&lang=ts&"
import style0 from "./OptionsPopover.vue?vue&type=style&index=0&id=149a8264&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149a8264",
  null
  
)

export default component.exports